export function registerPwa({ isTgApp = false } = {}) {
  if (!('serviceWorker' in navigator)) {
    return
  }

  if (isTgApp) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister())
    })
    return
  }

  let refreshing = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) {
      return
    }
    refreshing = true
    window.location.reload()
  })

  const register = () => {
    navigator.serviceWorker
      .register(`${process.env.BASE_URL || '/'}sw.js`)
      .catch((error) => {
        console.warn('[pwa] service worker registration failed', error)
      })
  }

  if (document.readyState === 'complete') {
    register()
  } else {
    window.addEventListener('load', register)
  }
}
